<template>
  <v-progress-circular
    v-if="isMobileOrIPad"
    indeterminate
    color="primary"
    :size="30"
  />
  <Lottie
    v-else
    :options="defaultOptions"
    :height="140"
    style="max-width: 200px"
    renderer="svg"
  />
</template>
<script>
import Lottie from 'vue-lottie'
import Pc from '@/assets/images/ai-anim.json'
import DeviceMixin from '../mixins/device-mixin'
import PermissionsMixin from 'components/mixins/permissions-mixin'
export default {
  name: 'AiAnim',
  mixins: [DeviceMixin, PermissionsMixin],
  components: { Lottie },
  data() {
    return {
      defaultOptions: {
        animationData: Pc,
      },
    }
  },
}
</script>

<style scoped>
.centerize {
  position: absolute;
  padding: 6px;
  top: 25%;
  transform: translate(-50%, -50%);
  left: 50%;
}
</style>
